import React, { useState, useEffect } from "react";
import SideBar from "../components/SideBar";
import TopBar from "../components/TopBar";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function PrayerHistory() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  const getInitials = (name) => {
    if (!name) return "A";
    const parts = name.trim().split(" ");
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
  };

  useEffect(() => {
    const fetchPrayerRequests = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        toast.error("You must be logged in to view your prayer history.", {
          theme: "colored",
        });
        setLoading(false);
        return;
      }

      try {
       const TEST_BASE_URL = process.env.REACT_APP_BASE_URL;
        const res = await fetch(
          `${TEST_BASE_URL}/prayer-requests`,
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await res.json();

        if (!(res.ok && data.status === "success")) {
          toast.error(data.message || "Failed to load prayer history.", {
            theme: "colored",
          });
          setLoading(false);
          return;
        }

        const requestsArray = Array.isArray(data.data.data)
          ? data.data.data
          : [];

        const uniqueUserIds = [...new Set(requestsArray.map((r) => r.user_id))];

        const userPromises = uniqueUserIds.map((userId) =>
          fetch(`${TEST_BASE_URL}/users/${userId}`, {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
            .then((res) => res.json())
            .then((userData) => ({
              userId,
              avatar: userData.data?.avatar,
              name: userData.data?.name,
            }))
            .catch(() => ({ userId, avatar: null, name: "Member" }))
        );

        const usersInfo = await Promise.all(userPromises);

        const requestsWithUsers = requestsArray.map((req) => {
          const user = usersInfo.find((u) => u.userId === req.user_id);
          return { ...req, avatar: user?.avatar, userName: user?.name };
        });

        setRequests(requestsWithUsers);
      } catch (err) {
        console.error("Error fetching prayer history:", err);
        toast.error("Network error — please try again.", { theme: "colored" });
      } finally {
        setLoading(false);
      }
    };

    fetchPrayerRequests();
  }, []);

  return (
    <section className="dashboard">
      <SideBar isOpen={sidebarOpen} />
      <div className="body-content">
        <TopBar onToggleSidebar={toggleSidebar} />
        <div
          className={`bottom-content ${
            loading || requests.length === 0 ? "full-height" : "fit-height"
          }`}
        >
          <h5>Prayer Request History</h5>

          {loading ? (
            <p>Loading prayer requests...</p>
          ) : requests.length === 0 ? (
            <p>No prayer requests found.</p>
          ) : (
            <div className="row equal-height">
              {requests.map((req, index) => {
                let avatarUrl = null;

                if (!req.is_shared_anonymously && req.avatar) {
                  if (
                    req.avatar.startsWith(
                      "https://rccgbournemouth.org/storage/"
                    )
                  ) {
                    avatarUrl = req.avatar; 
                  } else {
                    avatarUrl = `https://rccgbournemouth.org/storage/${req.avatar}`;
                  }
                }


                return (
                  <div className="col-md-4 mb-4 d-flex" key={index}>
                    <div className="request-card flex-fill d-flex flex-column justify-content-between">
                   
                      <div
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "50%",
                          overflow: "hidden",
                          background: "#0045e8",
                          color: "white",
                          fontWeight: "bold",
                          fontSize: "22px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginBottom: "10px",
                        }}
                      >
                        {avatarUrl && !req.is_shared_anonymously ? (
                          <img
                            src={avatarUrl}
                            alt={req.userName || "Member"}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.style.display = "none";
                              e.target.parentNode.textContent = getInitials(
                                req.userName
                              );
                            }}
                          />
                        ) : (
                          getInitials(req.userName)
                        )}
                      </div>

                     
                      <p
                        className="pt-3 flex-grow-1"
                        style={{ fontSize: "14px" }}
                      >
                        <small>{req.request}</small>
                      </p>

                      {req.is_shared_anonymously && (
                        <span
                          className="badge bg-secondary mt-2"
                          style={{ alignSelf: "flex-start" }}
                        >
                          Anonymous
                        </span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default PrayerHistory;
